import { Label, Coordinates, FOV, findTypedAttribute } from '@shared';
import { z } from 'zod';

export type GeoItem = Coordinates & {
    label: string;
    id: number;
    color: string;
};

export type MetadataLabel = z.infer<typeof MetadataLabel>;
export const MetadataLabel = Label.extend({
    name: z.literal('camera'),
    type: z.literal('tag'),
}).transform((label, ctx) => {
    const location = findTypedAttribute(label.attributes, 'location', Coordinates);
    const fov = findTypedAttribute(label.attributes, 'fov', FOV);

    if (!location.success || !fov.success) {
        if (!location.success) location.error.issues.forEach(ctx.addIssue);
        if (!fov.success) fov.error.issues.forEach(ctx.addIssue);
        return z.NEVER;
    }

    return { ...label, types: { location: location.data, fov: fov.data } };
});

export type GeolocatedLabel = z.infer<typeof GeolocatedLabel>;
export const GeolocatedLabel = Label.transform((label, ctx) => {
    const location = findTypedAttribute(label.attributes, 'location', Coordinates);

    if (!location.success) {
        location.error.issues.forEach(ctx.addIssue);
        return z.NEVER;
    }
    return { ...label, types: { location: location.data } };
});
